import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { isEmptyString, isNotEmptyString, isNullOrUndefined } from '@vy/utils';
import React, { useState } from 'react';
import { useMenu } from '../../../../hooks/use-menu';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import { AssignPaymentToInvoiceDialog } from './AssignPaymentToInvoiceDialog';

type PaymentOverviewTableDotMenuProps = {
  invoiceId?: string;
  externalInvoiceUrl?: string;
  paymentId: string;
  customerId: string;
};

export const PaymentOverviewTableDotMenu: React.FC<PaymentOverviewTableDotMenuProps> = ({
  invoiceId,
  externalInvoiceUrl,
  paymentId,
  customerId,
}) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();
  const navigate = useVyNavigate();
  const [isAssignDialogOpen, setIsAssignDialogOpen] = useState(false);

  const handleAssignMenuItemClick = () => {
    handleMenuClose();
    setIsAssignDialogOpen(true);
  };

  const handleAssignDialogClose = () => {
    setIsAssignDialogOpen(false);
  };

  const isPaymentUnlinked = isNullOrUndefined(invoiceId);

  return (
    <>
      <IconButton onClick={handleMenuOpen} className="aspect-square rounded-full">
        <span className="bg-[#5F6978] text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-full shadow-[0_7px_0_#5F6978,0_-7px_0_#5F6978]"></span>
      </IconButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            className: 'max-w-[250px] w-full shadow-xl',
          },

          list: {
            className: 'py-0',
          }
        }}>
        <MenuItem
          className="pl-2"
          disabled={isEmptyString(externalInvoiceUrl) && isEmptyString(invoiceId)}
          onClick={() =>
            isNotEmptyString(externalInvoiceUrl)
              ? window.open(externalInvoiceUrl, '_blank')
              : navigate(`/invoices/overview/light/${invoiceId}`)
          }
        >
          <Typography>Show Invoice</Typography>
        </MenuItem>
        {isPaymentUnlinked && (
          <MenuItem className="pl-2" onClick={handleAssignMenuItemClick}>
            <Typography>Assign to Invoice</Typography>
          </MenuItem>
        )}
      </Menu>
      {isAssignDialogOpen && (
        <AssignPaymentToInvoiceDialog
          open={isAssignDialogOpen}
          onClose={handleAssignDialogClose}
          paymentId={paymentId}
          customerId={customerId}
        />
      )}
    </>
  );
};
